import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Box, IconButton, TextField, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import Grid from "@mui/material/Grid2";
import "../historyDetail.scss";
import moment from "moment";
import { UrlWithStringQuery } from "url";

interface Props {
    setShowDetails: any;
    details: any;
    activityType: string;
}

interface Details {
    id: string;
    type: any;
    value: any;
    variable: string;
}
export const HistoricalActivitiesDetails = ({
    setShowDetails,
    details,
    activityType,
}: Props) => {
    const handleClose = () => {
        setShowDetails(false);
    };

    const [variablesToUpdate, setVariablesToUpdate] = useState<any>(undefined)

    const capitalizarPrimeraLetra = (str: string) => {
        const texto = String(str || "").trim();
        return texto.charAt(0).toUpperCase() + texto.slice(1);
    }


    return (
        <Box>
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    mt: 3,
                }}
            >
                <IconButton
                    aria-label="delete"
                    onClick={handleClose}
                    sx={{
                        backgroundColor: "#03365e",
                        color: "#fff",
                        "&:hover": {
                            backgroundColor: "#129ED3",
                        },
                    }}
                >
                    <ArrowBackIcon />
                </IconButton>
            </Box>

            <Box sx={{ mt: 3 }}>
                <Typography variant="h6" color="initial">
                    Actividad Requerida : <strong>{activityType}</strong> - {details?.executedBy} - {moment(details?.executedDate).format("DD-MM-YYYY")}
                </Typography>
            </Box>

            <Box className="list_activities_variables">
                <Grid className="variables-list-section">
                    {details?.variables.map((variable: any, index: number) => {
                        if (["Comentario", "Cuadrilla", "Ingenieros"].includes(variable.variable)) return null
                        return (
                            <Grid key={index}>
                                <TextField
                                    id="variable"
                                    size="small"
                                    onChange={(e) =>
                                        variable?.variableIdToEdit &&
                                        setVariablesToUpdate({
                                            ...variablesToUpdate,
                                            [variable?.variableIdToEdit]:
                                                e.target.value,
                                        })
                                    }
                                    label={variable.variable}
                                    value={
                                        variablesToUpdate?.[
                                            variable?.variableIdToEdit
                                        ] ||
                                        capitalizarPrimeraLetra(variable.value)
                                    }
                                    fullWidth
                                    sx={{
                                        backgroundColor:
                                            variable?.variableIdToEdit
                                                ? "white"
                                                : "#f5f5f5",
                                    }}
                                />
                            </Grid>
                        );
                    })}
                </Grid>
                {details?.variables?.find((variable: any) => variable.variable === "Comentario") && (
                    <Grid className="comment-section">
                        <Typography variant="subtitle2" sx={{ color: 'rgba(0, 0, 0, 0.6)' }}>Comentarios</Typography>
                        <Grid className="comment-value">
                            {details?.variables?.find((variable: any) => variable.variable === "Comentario")?.value || ""}
                        </Grid>
                    </Grid>
                )}
                {/* {details.map((detail: Details, index: number) => {
                    return (
                        <Box
                            key={index}
                            sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                mb: 1,
                                p: 1,
                                borderBottom: "1px solid #ddd",
                            }}
                        >
                            <Typography
                                variant="body1"
                                color="textPrimary"
                                sx={{ pr: 2 }}
                            >
                                {detail.variable}
                            </Typography>
                            <Typography
                                variant="body1"
                                color="textSecondary"
                                sx={{ pl: 2 }}
                            >
                                {detail.value}
                            </Typography>
                        </Box>
                    );
                })} */}
            </Box>
        </Box>
    );
};
